import React, { useState } from 'react' 
import NotificationCenter from '../NotificationCenter/NotificationCenter';
import { MdPerson } from "react-icons/md";
import { HiRefresh } from "react-icons/hi";

const App_Header = ({ userProfile, clearBrowserCache, handleLogout, user, handleRefresh, isRefreshing }) => {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <header className='relative min-w-0'>
      <div className="app-header gap-2 sm:gap-3">
        <div className='flex gap-2 items-center min-w-0 flex-1'>
          <img src="/seazen-logo.svg" className='h-10 sm:h-12 shrink-0' alt="Seazen HRMS Logo"/>
        <h1 className="truncate text-[1.35rem] sm:text-[1.8rem]">HRIS</h1>
        </div>
        <div className="flex items-center gap-2 sm:gap-[1rem] user-info shrink-0">
          <span className="currency-indicator hidden sm:flex">🇰🇼 KWD</span>
          <NotificationCenter userProfile={userProfile} />
          <div className='hidden lg:flex items-center gap-2'>
            <span className={`role-badge ${userProfile?.role || 'staff'}`}>
              {userProfile?.role?.toUpperCase() || 'STAFF'}
            </span>
            <span>Welcome, {user.name || user.username}</span>
              <button onClick={handleRefresh} className="refresh-button text-2xl" title="Force Refresh">
                <HiRefresh className='refresh-icon text-[19px]' style={isRefreshing ? { animation: 'spin 0.5s linear infinite' } : {}}/>
              </button>
            <button onClick={handleLogout} className="logout-button">
              🚪 Logout
            </button>
          </div>
          <span className='flex lg:hidden'>  <button onClick={handleRefresh} className="refresh-button" title="Force Refresh">
             <HiRefresh className='refresh-icon !text-[19px]'/>
          </button>
          </span>
          <button
            className="profile-button flex lg:hidden text-[22px]"
            onClick={() => setShowMenu(!showMenu)}
          >
            <MdPerson/>
          </button>
        </div>

      </div>
      {showMenu && (
        <div className="app_header_mobile z-10 rounded-lg shadow-sm w-[min(100vw-1rem,280px)] max-w-[calc(100vw-1rem)] absolute top-[60px] right-2 sm:right-0 flex flex-col items-stretch lg:hidden gap-2 px-4 py-3 user-info">
          <span className={`role-badge ${userProfile?.role || 'staff'}`}>
            {userProfile?.role?.toUpperCase() || 'STAFF'}
          </span>
          <span className='text-center'>Welcome, {user.name || user.username}</span>
          <span className='flex sm:hidden'><span className="logout_button_mobile">🇰🇼 KWD</span></span>
          <button onClick={handleLogout} className="logout-button">
            🚪 Logout
          </button>
        </div>
      )}
    </header>
  )
}

export default App_Header